import { lazy } from 'react';

export const RunwayInFlightPage = lazy(() => import('./pages/InFlightV2'));
export const RunwayStartNewPage = lazy(() => import('./pages/StartNewPage'));
export const RunwayHandoffsPage = lazy(() => import('./pages/HandoffsPage'));
export const RunwayHistoryPage = lazy(() => import('./pages/HistoryPage'));
export const RunwayInstanceDetailPage = lazy(() => import('./pages/InstanceDetailPage'));
export const RunwayIntranetTemplatePage = lazy(() => import('./pages/IntranetTemplateLaunchPage'));
